(() => {
  const normalize = (value) => value.replace(/\s+/gu, '');
  const links = (root) => Array.from(root.querySelectorAll('a,form,input,button,select,textarea')).map((node) => ({
    tag: node.tagName,
    attributes: Array.from(node.attributes).map(({ name, value }) => [name, value]).sort(),
    text: node.textContent,
  }));
  const isHeading = (node) => {
    if (node.nodeType !== 1) return false;
    if (/^H[1-6]$/.test(node.tagName)) return !!node.textContent.trim();
    if (node.tagName !== 'P') return false;
    const bold = Array.from(node.children);
    return bold.length > 0 && bold.every((child) => ['STRONG', 'B'].includes(child.tagName)) && normalize(bold.map((child) => child.textContent).join('')) === normalize(node.textContent) && !!normalize(node.textContent);
  };
  const enhance = (root) => {
    if (root.dataset.enhanced) return;
    const content = root.querySelector('[data-policy-content]');
    const navigation = root.querySelector('[data-policy-navigation]');
    const toc = root.querySelector('.kw-policy-toc');
    if (!content || !navigation || !toc) return;
    const clone = content.cloneNode(true);
    const beforeText = normalize(clone.textContent);
    const beforeLinks = JSON.stringify(links(clone));
    const output = document.createDocumentFragment();
    const items = [];
    let card;
    let rules;
    const makeCard = (heading, kind = '') => {
      card = document.createElement('section');
      card.className = `kw-policy-card ${kind}`.trim();
      const title = document.createElement('h2');
      title.append(...Array.from(heading.childNodes));
      title.id = `policy-${root.dataset.policyHandle}-${items.length + 1}`;
      card.setAttribute('aria-labelledby', title.id);
      card.id = `${title.id}-section`;
      card.append(title);
      items.push({ title: title.textContent, id: card.id });
      output.append(card);
      rules = null;
      return card;
    };
    for (const node of Array.from(clone.childNodes)) {
      if (!normalize(node.textContent) && !(node.nodeType === 1 && node.querySelector('img,iframe,form,input,video'))) continue;
      if (isHeading(node)) {
        makeCard(node, items.length === 0 ? 'kw-policy-card--intro' : '');
        continue;
      }
      if (!card) {
        card = document.createElement('section');
        card.className = 'kw-policy-card';
        output.append(card);
      }
      if (root.dataset.policyHandle === 'returns-refunds' && node.nodeType === 1) {
        if (node.tagName === 'P' && node.textContent.trim().startsWith('UK Based customers can return orders to')) {
          const heading = document.createElement('h2');
          heading.textContent = root.dataset.addressLabel;
          makeCard(heading, 'kw-policy-card--address');
          card.querySelector('h2').dataset.policyAdded = 'true';
        }
        if (node.tagName === 'DIV' && /^[1-7]\.\s/.test(node.textContent.trim())) {
          if (!rules) {
            rules = document.createElement('ol');
            rules.className = 'kw-policy-rules';
            card.append(rules);
          }
          let item = document.createElement('li');
          for (const part of Array.from(node.childNodes)) {
            if (part.nodeType === 1 && part.tagName === 'BR') {
              if (normalize(item.textContent)) rules.append(item);
              item = document.createElement('li');
            } else {
              item.append(part);
            }
          }
          if (normalize(item.textContent)) rules.append(item);
          continue;
        }
        if (node.tagName === 'DIV' && node.textContent.trim().startsWith('Kicks Worldwide')) node.classList.add('kw-policy-address');
        if (node.tagName === 'P' && node.textContent.trim().startsWith('Returned shoes are passed through Quality Control')) node.classList.add('kw-policy-note');
      }
      card.append(node);
    }
    const audit = document.createElement('div');
    audit.append(output);
    const auditClone = audit.cloneNode(true);
    auditClone.querySelectorAll('[data-policy-added]').forEach((node) => node.remove());
    if (normalize(auditClone.textContent) !== beforeText || JSON.stringify(links(auditClone)) !== beforeLinks || items.length < 2) return;
    if (root.dataset.policyHandle === 'delivery-information') {
      Array.from(audit.children).forEach((section, index) => {
        if ([0, 1, 4, 5].includes(index)) section.classList.add('kw-policy-card--compact');
      });
    }
    const nav = document.createDocumentFragment();
    items.forEach((item, index) => {
      const link = document.createElement('a');
      link.href = `#${item.id}`;
      const number = document.createElement('span');
      number.setAttribute('aria-hidden', 'true');
      number.textContent = String(index + 1).padStart(2, '0');
      const label = document.createElement('div');
      label.textContent = item.title;
      link.append(number, label);
      nav.append(link);
    });
    content.replaceChildren(...Array.from(audit.childNodes));
    content.classList.add('is-enhanced');
    navigation.replaceChildren(nav);
    toc.hidden = false;
    toc.open = !window.matchMedia('(max-width:700px)').matches;
    root.dataset.enhanced = 'true';
  };
  document.querySelectorAll('[data-kw-policy]').forEach(enhance);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-kw-policy]').forEach(enhance);
  });
})();
